import React from 'react';
import { Button } from 'react-bootstrap';
import { CHANGE_INSIGHT_SURVEY_STATUSES } from '../../../lib/schema.js';
import CompletionDate from '../../CompletionDate.jsx';
import EmployeeLabel from '../../employees/EmployeeLabel.jsx';
import ParticipationLabel from '../ParticipationLabel.jsx';

const ParticipationsTableRow = ({
  typeParticipating,
  isPreview,
  initiative,
  initiativeParticipation,
  handleClickViewRespondentAnswers,
  survey,
  query,
  depth,
}) => {
  const {
    childrenCount,
    surveyStatus,
    surveyResponseId,
    label,
    participantId,
    participantType,
    archived,
  } = initiativeParticipation;

  const renderParticipantCell = () => {
    return participantType === 'Employee' ? (
      <td>
        <div style={{ paddingLeft: `${depth * 24}px` }}>
          <EmployeeLabel
            employeeId={participantId}
            employeeName={label}
            archived={archived}
          />
        </div>
      </td>
    ) : (
      <td>
        <strong className={archived ? 'text-muted' : ''}>{label}</strong>
      </td>
    );
  };

  const renderSurveyStatusCell = () => {
    if (participantType === 'Group') {
      return (
        <td>
          {!childrenCount ? (
            '—'
          ) : (
            <p className="m-b-0">
              <strong>{CHANGE_INSIGHT_SURVEY_STATUSES[surveyStatus]}</strong>
            </p>
          )}
        </td>
      );
    }
    return (
      <td>
        {surveyStatus &&
        (childrenCount ||
          participantType === 'Employee' ||
          participantType === 'individual') ? (
          <div>
            <p className="m-b-0">
              <strong>{CHANGE_INSIGHT_SURVEY_STATUSES[surveyStatus]}</strong>
            </p>
            <div className="text-details">
              {participantType === 'Employee' ||
              participantType === 'individual' ? (
                <CompletionDate
                  completedAt={initiativeParticipation.surveyCompletedAt}
                  endDate={survey.endDate}
                />
              ) : null}
            </div>
          </div>
        ) : null}
      </td>
    );
  };

  const renderSurveyActionCell = () => {
    return (
      <td>
        {participantType === 'Employee' || participantType === 'individual' ? (
          <div className="flex flex-end">
            <Button
              onClick={() => handleClickViewRespondentAnswers(surveyResponseId)}
              bsStyle="primary"
              disabled={surveyStatus !== 'completed'}
            >
              View
            </Button>
          </div>
        ) : null}
      </td>
    );
  };

  const renderParticipantInfo = () => {
    if (childrenCount) {
      return (
        <React.Fragment>
          <td>
            <ParticipationLabel
              typeParticipating={typeParticipating}
              isPreview={isPreview}
              initiative={initiative}
              initiativeParticipation={initiativeParticipation}
              showSurvey
              query={query}
            />
          </td>
          {renderSurveyStatusCell()}
          {renderSurveyActionCell()}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {renderParticipantCell()}
        {renderSurveyStatusCell()}
        {renderSurveyActionCell()}
      </React.Fragment>
    );
  };

  return (
    <tr style={{ borderBottom: '1px solid #dfe2e5' }}>
      {renderParticipantInfo()}
    </tr>
  );
};

export default ParticipationsTableRow;
